var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    throttle: 100,
  }),expression:"{\n    callback: visibilityChanged,\n    throttle: 100,\n  }"}]},[(_vm.active)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.data.src,"height":_vm.data.height,"width":_vm.data.width,"frameborder":"0","scrolling":"no"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }